// @flow
import React, { Component } from 'react';
import {
  TextArea, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button } from '../../../Buttons.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initPsychosocial: Object,
  resetAnxietyRadios: Function,
}

class EditPsychosocial extends Component<Props> {
  render() {
    const psychosocial = this.props.initPsychosocial || {};
    return (
      <ContentBox title='Psychosocial'>
        <div className={styles.col}>
          <div className={styles.section}>
            <SecondaryText>Objective evaluation of anxiety</SecondaryText><br />
            <Button onClick={this.props.resetAnxietyRadios}>Clear Radios</Button><br />
            <RadioGroup field='psychosocial.objectiveEval' initialValue={psychosocial.objectiveEval}>
              <Radio value='mild' />Mild anxiety: Patient is alert, calm, speaks clearly<br />
              <Radio value='moderate' />Moderate anxiety: Patient displays muscle tension, appears nervous<br />
              <Radio value='sever' />Severe anxiety: Patient has dry mouth, diaphoresis, trouble focusing, urinary urgency<br />
              <Radio value='panic' />Panic: Patient is hyperventilating, displays impaired thinking, appears terrified
            </RadioGroup>
          </div>
          <PrimaryText>Assessment for Adolescents (Adopted from HEADSS Assessment)</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>This is an interview instrument for finding out issues in adolescents&apos; lives.</SecondaryText>
          </div>
          <div className={styles.section}>
            <SecondaryText>Home</SecondaryText><br />
            What are relationships like at home?<br />
            <TextArea field='psychosocial.homeRelations' initialValue={psychosocial.homeRelations} /><br />
            New people in home environment?<br />
            <TextArea field='psychosocial.homeNew' initialValue={psychosocial.homeNew} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Education</SecondaryText><br />
            School/grade performance - any recent changes? Any dramatic past changes?<br />
            <TextArea field='psychosocial.eduPerf' initialValue={psychosocial.eduPerf} /><br />
            Favorite subjects? Worst subjects?<br />
            <TextArea field='psychosocial.subjects' initialValue={psychosocial.subjects} /><br />
            Any years repeated/classes failed?<br />
            <TextArea field='psychosocial.fails' initialValue={psychosocial.fails} /><br />
            Future education/employment plans?<br />
            <TextArea field='psychosocial.plans' initialValue={psychosocial.plans} /><br />
            Relations with teachers<br />
            <TextArea field='psychosocial.teachers' initialValue={psychosocial.teachers} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Activities</SecondaryText><br />
            On own, with peers (what do you do for fun? where? when?)<br />
            <TextArea field='psychosocial.fun' initialValue={psychosocial.fun} /><br />
            Sports - regular exercise?<br />
            <TextArea field='psychosocial.sports' initialValue={psychosocial.sports} /><br />
            Church attendance, clubs, projects?<br />
            <TextArea field='psychosocial.clubs' initialValue={psychosocial.clubs} /><br />
            Hobbies - other activities?<br />
            <TextArea field='psychosocial.hobbies' initialValue={psychosocial.hobbies} /><br />
            Reading for fun - what?<br />
            <TextArea field='psychosocial.reading' initialValue={psychosocial.reading} /><br />
            TV - how much weekly - favorite shows?<br />
            <TextArea field='psychosocial.tv' initialValue={psychosocial.tv} /><br />
            Favorite music?<br />
            <TextArea field='psychosocial.music' initialValue={psychosocial.music} /><br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Suicide/depression</SecondaryText><br />
            Sleep disorders (usually induction problems, also early/frequent
              waking or greatly increased sleep and complaints of increasing fatigue)<br />
            <TextArea field='psychosocial.sleep' initialValue={psychosocial.sleep} /><br />
            Appetite/eating behavior changes<br />
            <TextArea field='psychosocial.appetite' initialValue={psychosocial.appetite} /><br />
            Feelings of &quot;boredom&quot;<br />
            <TextArea field='psychosocial.boredom' initialValue={psychosocial.boredom} /><br />
            Emotional outbursts and highly impulsive behavior<br />
            <TextArea field='psychosocial.outbursts' initialValue={psychosocial.outbursts} /><br />
            History of withdrawal/isolation<br />
            <TextArea field='psychosocial.withdrawal' initialValue={psychosocial.withdrawal} /><br />
            Hopeless/helpless feelings<br />
            <TextArea field='psychosocial.hopeless' initialValue={psychosocial.hopeless} /><br />
            Psychosomatic symptomology<br />
            <TextArea field='psychosocial.psychosomatic' initialValue={psychosocial.psychosomatic} /><br />
            Suicidal ideation<br />
            <TextArea field='psychosocial.suicide' initialValue={psychosocial.suicide} /><br />
            Decreased affect on interview, avoidance of eye contact - depression posturing<br />
            <TextArea field='psychosocial.lowAffect' initialValue={psychosocial.lowAffect} /><br />
            Preoccupation with death (clothing, media, music, art)<br />
            <TextArea field='psychosocial.death' initialValue={psychosocial.death} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditPsychosocial;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditPsychosocial.jsx